import {
    REGISTRATION_ROUTE,
    REGISTRATION_ROUTE_AFTER,
    REGISTRATION_ROUTE_AFTER_HATCH,
    EXISTING_USER_CHECK_ROUTE
} from './constants';

import http from '../../../utils/httpService';
import { getCookie } from '../../../utils/cookieService';

/**
 *
 * @param regForm
 * @returns {*}
 */
const sendRegistrationForm = ( regForm ) => {
    const route = REGISTRATION_ROUTE;
    const uuid = getCookie( 'uuid' );

    const regFormBody = {
        uuid_front: uuid,
        ...regForm
    };

    return http.request( route, 'POST', regFormBody )
};
/**
 *
 * @param regForm
 * @returns {*}
 */
const sendRegistrationFormAfter = ( regForm ) => {
    const route = REGISTRATION_ROUTE_AFTER;
    const uuid = getCookie( 'uuid' );

    const regFormBody = {
        uuid_front: uuid,
        ...regForm
    };

    return http.request( route, 'POST', regFormBody );
};
/**
 *
 * @param regForm
 * @returns {*}
 */
const sendRegistrationFormAfterHatch = ( regForm ) => {
    const route = REGISTRATION_ROUTE_AFTER_HATCH;
    const uuid = getCookie( 'uuid' );

    const regFormBody = {
        uuid_front: uuid,
        ...regForm
    };

    return http.request( route, 'POST', regFormBody );
};
/**
 *
 * @param email
 * @param id
 * @returns {*}
 */
const requestPlayerByEmail = ( email, id ) => {
    const emailObj = { email, regsource_id: id, regsource_type: 'calendar' };
    return http.request( EXISTING_USER_CHECK_ROUTE, 'POST', emailObj );
};
/**
 *
 * @param email
 * @param id
 * @returns {*}
 */
const requestQuizPlayerByEmail = ( email, id ) => {
    const emailObj = { email, regsource_id: id, regsource_type: 'quizlocalization' };
    return http.request( EXISTING_USER_CHECK_ROUTE, 'POST', emailObj );
};

export {
    sendRegistrationForm,
    sendRegistrationFormAfter,
    sendRegistrationFormAfterHatch,
    requestPlayerByEmail,
    requestQuizPlayerByEmail
};
